module.exports = __webpack_public_path__ + "static/assets/08dff6089c2812aaac7dc2ceed178351.png";